module.exports = __webpack_public_path__ + "img/blue_bay_balcony_302.b7ba7c28.jpeg";